<script src="./index.js"></script>
<style src="./style.scss" lang="scss" scoped/>
<template>
  <div class="input-field">
    <input type="checkbox" @input="handleInput" v-model="isChecked" :value="value" :checked="checked">
  </div>
</template>

